import React, {useEffect} from "react";
import {Filter} from "./filter";
import {OrderList} from "./order-list";
import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {useParams} from "react-router-dom";
import {setToolsInitialState} from "../../../reducers/tools.reducer";

const TabOrder = () => {
    const dispatch = useDispatch()
    const {id} = useParams()
    const {currentPage, pageSize, searchKey} = useSelector(state => state.toolsReducer)
    const queryParams = {
        page: currentPage,
        perPage: pageSize,
        search: searchKey,
    }
    const {data: response, fetching: getOrderList, isLoading} = useFetch({...API.USER_ORDER_LIST, ...{initPathVariable: id}}, queryParams, {isWithTotalData: true})

    useEffect(() => {
        getOrderList()
    }, [currentPage, pageSize, searchKey, id])

    useEffect(() => {
        return () => {
            dispatch(setToolsInitialState())
        }
    }, [])

    return (
        <div className={"px-10 space-y-5"}>
            <Filter/>
            <OrderList dataSource={response?.data?.result ?? []} isLoading={isLoading}/>
        </div>
    )
}

export default TabOrder
